import styled from 'styled-components';
import React from 'react';

interface TestStartModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  data: {
    title: string;
    desiredTesterCount: number;
    totalPlimoney: number;
    userPlimoney: number;
    schedule: {
      recruitStartedAt: string;
      recruitExpiredAt: string;
      startedAt: string;
      expiredAt: string;
    }
  };
  // gameTitle: string;
  // recruitPeriod: {
  //   start: string;
  //   end: string;
  //   days: number;
  // };
  // testPeriod: {
  //   start: string;
  //   end: string;
  // };
  // maxParticipants: number;
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 380px;
  background: white;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  z-index: 1000;
`;

const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 25px;
  text-align: center;
`;

const ModalContent = styled.div`
  font-size: 14px;
  margin-bottom: 25px;
  line-height: 1.8;
  color: #2282E9;
  display: flex;
  flex-direction: column;
  gap: 9px;
  text-align: center;
`;

const ContentRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Label = styled.span`
  color: #2282E9;
  margin-bottom: 2px;
`;

const Value = styled.span`
  font-weight: 500;
  color: #2282E9;
`;

const ModalButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 15px;
  flex-direction: column;
`;

const CancelButton = styled.button`
  width: 150px;
  height: 45px;
  border-radius: 100px;
  border: 1px solid #e0e0e0;
  background: #cccccc;
  color: white;
  cursor: pointer;
  font-weight: 500;
`;

const ConfirmButton = styled.button<{ disabled: boolean }>`
  width: 150px;
  height: 45px;
  border-radius: 100px;
  border: none;
  background: ${({ disabled }) => disabled ? '#cccccc' : '#2282E9'};
  color: white;
  // cursor: pointer;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  font-weight: 500;
`;

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}.${month}.${day}`;
};
// 날짜 차이 계산 함수 (일 수)
const calculateDaysDifference = (startDate: string, endDate: string) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end.getTime() - start.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};
// 시간 포함 날짜 포맷 함수
const formatDateWithTime = (dateString: string) => {
  const date = new Date(dateString);
  const isStartOfDay = date.getHours() === 0 && date.getMinutes() === 0;
  const isEndOfDay = date.getHours() === 23 && date.getMinutes() === 59;

  const formattedDate = formatDate(dateString);

  if (isStartOfDay) {
    return `${formattedDate} (00시)`;
  } else if (isEndOfDay) {
    return `${formattedDate} (자정)`;
  } else {
    return formattedDate;
  }
};

export default function CheckTestStartModal({
  isOpen,
  onClose,
  onConfirm,
  data,
}: TestStartModalProps) {
  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <Modal>
        <ModalTitle>테스트를 시작하시겠습니까?</ModalTitle>

        <ModalContent>
          <ContentRow>
            <Label>게임 이름 : &nbsp;</Label>
            <Value>{data?.title}</Value>
          </ContentRow>

          <ContentRow>
            <Label>모집일정 : &nbsp;</Label>
            <Value>{formatDate(data?.schedule?.recruitStartedAt)} - {formatDate(data?.schedule?.recruitExpiredAt)} ({calculateDaysDifference(data?.schedule?.recruitExpiredAt, data?.schedule?.recruitStartedAt)}일)</Value>
          </ContentRow>

          <ContentRow>
            <Label>테스트 일정 :&nbsp; </Label>
            <Value>{calculateDaysDifference(data?.schedule?.expiredAt, data?.schedule?.startedAt)}일</Value>  
          </ContentRow>
          {formatDateWithTime(data?.schedule?.startedAt)} - {formatDateWithTime(data?.schedule?.expiredAt)}
          {/* <Value></Value> */}
          

          <ContentRow>
            <Label>최대 참여 유저 : &nbsp;</Label>
            <Value>{data?.desiredTesterCount}명</Value>
          </ContentRow>
        </ModalContent>

        <ModalButtonContainer>
          <div style={{ display: 'flex', gap: '10px' }}>
            <CancelButton onClick={onClose}>취소</CancelButton>
            <ConfirmButton disabled={data.userPlimoney < data.totalPlimoney}

              onClick={onConfirm}>지금 바로 시작</ConfirmButton>
          </div>
          {data.userPlimoney < data.totalPlimoney && <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>플리머니가 부족합니다.</span>}
        </ModalButtonContainer>
      </Modal>
    </>
  );
} 